import React from 'react'
import Styles from "./FJCloudFreeButton.module.less";
import FJLocalStore from "../../../../store/FJLocalStore";
import FJVip from "../../../../common/component/FJVip";

function FJCloudFreeButton(props) {
  const {onClick} = props;
  return (
    <button onClick={onClick} className={Styles.btn_cloud}>
      <FJVip id1='FJCloudFreeButton-1' id2='FJCloudFreeButton-2' />
      <span>{FJLocalStore._('turn-on-cloud')}</span>
    </button>
  );
}

export default FJCloudFreeButton;